// The only dial code the app supports today. Kept private so the exports below
// are the single way to add or remove it — the two must not drift.
const DIAL_CODE = '62'

/** What a phone field displays, and what is prefixed onto a submitted number. */
export const PHONE_DIAL_CODE_PREFIX = `+${DIAL_CODE}`

// Anchored, and the '+' is optional: we submit '+628…', but the BE returns
// '628…' — E.164 without the plus — and both have to strip.
const DIAL_CODE_PATTERN = new RegExp(`^\\+?${DIAL_CODE}`)

/**
 * Returns the local part of a phone number, without its country code.
 *
 * Anchored to the start, so a `62` occurring inside the number is left alone —
 * `replace('+62', '')` would remove it from anywhere.
 *
 * A number that carries no dial code is returned unchanged rather than emptied:
 * `split('+62')[1]` yields `undefined` in that case, which silently blanks the
 * field it was prefilling.
 *
 * @param phone - Stored number, with or without the leading `+`. Null and
 *   undefined are tolerated because callers read it off an optional API field.
 *
 * @example
 * stripPhoneDialCode('628123456')   // => '8123456'
 * stripPhoneDialCode('+628123456')  // => '8123456'
 * stripPhoneDialCode('8123456')     // => '8123456'  (no dial code to remove)
 * stripPhoneDialCode(null)          // => ''
 */
export const stripPhoneDialCode = (
  phone?: string | null,
): string => (phone ?? '').replace(DIAL_CODE_PATTERN, '')

/**
 * Prefixes the dial code onto a local number, for submission.
 *
 * @example
 * withPhoneDialCode('8123456') // => '+628123456'
 */
export const withPhoneDialCode = (localNumber: string): string =>
  `${PHONE_DIAL_CODE_PREFIX}${localNumber}`
